<template>
	<div class="content-box">
		<h3 class="text-center mb-3">{{info.type.name}}</h3>
		<info-table
			ref="baseInfoTable"
			data-model-name="Transaction"
			:record-id="recordId"
			:fields="infoFields"
			:auto-load="false"
		></info-table>
	</div>
</template>

<script>
import TxOp from "@/mixinsApp/TxOp.js";
import TxInfo from "@/mixinsApp/TxInfo.js";

export default {
	mixins: [TxInfo, TxOp],
	data() {
		return {
			infoFields: [
				[
					{
						name: "customer",
						col: 2,
					},
					{
						name: "warehouse",
						col: 2,
					},
					{
						name: "show_id",
						col: 2,
					},
				],
				[
					{
						name: "order",
						col: 3,
					},
					{
						name: "order_show_id",
						col: 2,
					},
				],
				[
					{
						name: "express_type",
						col: 2,
					},
					{
						name: "address",
						col: 3,
					},
				],
				[
					{
						name: "desc",
						col: 5,
					},
				],
				[
					{
						name: "express",
						col: 2,
					},
					{
						name: "tracking_number",
						col: 2,
					},
					{
						name: "mobile_tail_no",
						col: 2,
					},
				],
				[
					{
						name: "discount",
						col: 2,
					},
					{
						name: "total_price",
						col: 2,
					},
					{
						name: "status",
						col: 2,
					},
				],
			],
		};
	},
	computed: {},
	created() {},
	mounted() {},
	methods: {},
	watch: {},
	components: {},
};
</script>
<style lang="scss" scoped>
</style>
